import { Identifiable, List, Project } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedList, LinkedResource, Linker } from "../linkers/types";

type Activity = LinkedList & {
  subActivities: LinkedResource<Identifiable<Activity>>[];
};

type Response = LinkedList & {
  activities: Activity[];
};

function renameActivities(
  activities: Identifiable<Activity>[],
  parentList?: Identifiable<Activity>,
): Identifiable<List>[] {
  return activities.map((activity) => ({
    ...activity,
    subLists: renameActivities(
      activity.subActivities || activity.activities || [],
      activity,
    ),
    parentList: activity.activityParent || parentList,
    tags: activity.tags
      ? (activity.tags as any).map((name: string) => ({ name }))
      : [],
    tasks: activity.tasks.map((task) => ({
      ...task,
      tags: task.tags
        ? (task.tags as any).map((name: string) => ({ name }))
        : [],
    })),
    milestones: Array.isArray(activity.milestones)
      ? activity.milestones.map((milestone) => ({
          ...milestone,
          tags: milestone.tags
            ? (milestone.tags as any).map((name: string) => ({ name }))
            : [],
        }))
      : [],
    events: Array.isArray(activity.events)
      ? activity.events.map((event) => ({
          ...event,
          tags: event.tags
            ? (event.tags as any).map((name: string) => ({ name }))
            : [],
        }))
      : [],
  }));
}

function getLists(httpClient: HttpClient, linker: Linker) {
  return ({ uuid }: Identifiable<Project>) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/projects/${uuid}?projection=gantt&embed_links=false`,
        method: HttpMethods.GET,
      })
      .then((project) => {
        const [rootList] = renameActivities(project.activities);

        return rootList ? rootList : Promise.reject();
      });
}

export { getLists };
